import { useState } from 'react'
import Disclaimer from './disclaimer'
import Demo from './demo'
import Questionnaire from './questionnair'
import SwitchLanguage from '@app/components/Switch'
import { LANGS } from '@app/constants'
import { useTypedDispatch, useTypedSelector } from '@app/store'
import { changeLanguage } from '@app/store/actions'
import { useLocalization } from '@app/hooks'
import Profile from '../profile'

const OnBoard: React.FC = () => {
  const { translate } = useLocalization()
  const [currentStep, setCurrentStep] = useState<'disclaimer' | 'demo' | 'profile' | 'questionnaire'>('disclaimer')
  const { language } = useTypedSelector(state => state.lang)
  const dispatch = useTypedDispatch()

  const [selectedLanguage, setSelectedLanguage] = useState<any>(language)
  const isRussian = selectedLanguage === LANGS.RUSSIAN

  const handleLanguageToggle = () => {
    const newLanguage = isRussian ? LANGS.ENGLISH : LANGS.RUSSIAN
    setSelectedLanguage(newLanguage)
    dispatch(changeLanguage(newLanguage))
  }

  return (
    <div className='relative h-screen w-screen bg-gray-100 '>
      <div className='absolute top-4 right-4 z-50'>
        <div className='scale-75 xs:scale-85 sm:scale-90'>
          <SwitchLanguage isChecked={isRussian} onHandleChange={handleLanguageToggle} />
        </div>
      </div>

      {currentStep === 'disclaimer' && <Disclaimer onNext={() => setCurrentStep('demo')} translate={translate} />}
      {currentStep === 'demo' && <Demo onNext={() => setCurrentStep('profile')} translate={translate} />}
      {currentStep === 'profile' && (
        <Profile onNext={() => setCurrentStep('questionnaire')} translate={translate} hideNav />
      )}
      {currentStep === 'questionnaire' && <Questionnaire translate={translate} />}
    </div>
  )
}

export default OnBoard
